module.exports = __webpack_public_path__ + "img/78.156d435.png";